import { Button, Grid2, Stack } from '@mui/material'
import { useApp } from '../contexts/AppContext'
import { ArrowDropDown } from '@mui/icons-material'
import { useState } from 'react'
import { TLang } from 'sierra'
import api from '../utils/axios'
import { useAuth } from '../hooks/useAuth'

const LangDropdown = () => {
    const { user } = useAuth()
    const { lang, setLang, languages, screenSize } = useApp()
    const [languageHovered, setLanguageHovered] = useState(false)

    const handleChangeLang = (lang: TLang) => {
        setLang(lang)
        localStorage.setItem('lang', lang)
        if (user) {
            api.patch(`/users/${user.user_id}/lang`, { lang }).catch(console.error)
        }
    }

    return (
        <Grid2 container size={'auto'} >
            <Grid2 container position={'relative'}>
                <Grid2 border={'5px solid transparent'} borderRadius={2}>
                    <Button
                        size="small"
                        sx={{ fontWeight: 'bold', paddingX: 0 }}
                        startIcon={<Stack gap={0.5} direction={'row'}> {languages.map(l => l.lang == lang ? l.icon : null)}</Stack>}
                        endIcon={<ArrowDropDown sx={{ color: t => t.palette.primary.main }} />}
                        onMouseEnter={() => setLanguageHovered(true)}
                    >
                        {!screenSize.xs && languages.find(e => e.lang == lang)?.title}
                    </Button>
                </Grid2>
                {languageHovered && (
                    <Grid2
                        zIndex={500}
                        container
                        position={'absolute'}
                        bgcolor={'white'}
                        onMouseLeave={() => setLanguageHovered(false)}
                        border={'5px solid lightgrey'}
                        borderRadius={2}
                    >
                        <Grid2>
                            <Button
                                size="small"
                                sx={{ color: 'midnightblue', fontWeight: 'bold', paddingX: 0 }}
                                startIcon={<Stack gap={0.5} direction={'row'}> {languages.map(l => l.lang == lang ? l.icon : null)}</Stack>}
                                endIcon={<ArrowDropDown sx={{ color: t => t.palette.primary.main }} />}
                                onMouseEnter={() => setLanguageHovered(true)}
                            >
                                {!screenSize.xs && languages.find(e => e.lang == lang)?.title}
                            </Button>
                        </Grid2>
                        {languages.map((l, i) =>
                            <Grid2 key={i} sx={{ display: l.lang == lang ? 'none' : null }} width={'100%'}>
                                <Button
                                    size="small"
                                    sx={{ textTransform: 'none', paddingX: 0, color: 'midnightblue', fontWeight: 'bold', width: '100%', display: 'flex', justifyContent: 'start', '&:hover': { color: 'white', backgroundColor: t => t.palette.primary.dark } }}
                                    startIcon={<Stack gap={0.5} direction={'row'}>{l.icon}</Stack>}
                                    onMouseEnter={() => setLanguageHovered(true)}
                                    onClick={() => handleChangeLang(l.lang)}
                                >
                                    {!screenSize.xs && l.title}
                                </Button>
                            </Grid2>
                        )}
                    </Grid2>)}
            </Grid2>
        </Grid2 >
    )
}

export default LangDropdown